import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({ ref: "select" }, _ctx.$attrs, {
    options: _ctx.filteredOptions,
    "option-label": _ctx.optionLabel,
    multiple: _ctx.multiple,
    "use-input": "",
    "fill-input": _ctx.singleValueMode,
    "hide-selected": _ctx.singleValueMode,
    "input-debounce": "0",
    onFilter: _ctx.onFilter
  }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, name) => {
      return {
        name: name,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(scope || {})))
        ])
      }
    }),
    (!_ctx.$slots['no-option'])
      ? {
          name: "no-option",
          fn: _withCtx(() => [
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["options", "option-label", "multiple", "fill-input", "hide-selected", "onFilter"]))
}